module.exports = __webpack_public_path__ + "static/media/dashboard.530879cb.png";